<template>
  <v-app>
    <div>
      <v-navigation-drawer
        id="core-navigation-drawer"
        v-model="drawer"
        color="#015A6C"
        mobile-break-point="960"
        app
        width="250"
        height="100%"
        class="main-navigation"
      >
        <v-list align="center" justify="center">
          <v-list-item class="nav-item active">
            <router-link to="/" style="margin-left: auto;margin-right:auto">
              <img
                src="/images/logo.png"
                alt="avatar"
                style="
              height: 43px;
              width: 153px;
              margin-top: 25px;
              margin-bottom: 25px;

            "
              />
            </router-link>
          </v-list-item>
          <v-list-item class="nav-item active">
            <router-link :to="{ name: 'home' }">My Utilities</router-link>
          </v-list-item>
          <v-list-item class="nav-item active">
            <router-link :to="{ name: 'utilitieshistory' }"
              >Utilities History</router-link
            >
          </v-list-item>
          <v-list-item class="nav-item active">
            <router-link :to="{ name: 'statistics' }">Statistics</router-link>
          </v-list-item>
          <hr
            style="
    width: 180px;
"
          />
          <v-list-item class="nav-item active">
            <router-link :to="{ name: 'myproviders' }"
              >My Providers</router-link
            >
          </v-list-item>
          <v-list-item class="nav-item active">
            <router-link :to="{ name: 'addnewprovider' }"
              >Add New Provider</router-link
            >
          </v-list-item>
          <hr
            style="
    width: 180px;
"
          />
          <v-list-item class="nav-item active">
            <router-link :to="{ name: 'mywallet' }">My Wallet</router-link>
          </v-list-item>
          <v-list-item class="nav-item active">
            <router-link :to="{ name: 'notificationscenter' }"
              >Notifications Center</router-link
            >
          </v-list-item>
          <v-list-item class="nav-item active">
            <router-link :to="{ name: 'recommendtofriend' }"
              >Recommend to Friend</router-link
            >
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar id="app-bar" color="#ffffff" app flat height="65" fixed>
        <v-btn class="mr-3" elevation="1" fab small @click="setDrawer(!drawer)">
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>

        <!-- <v-toolbar-title
          class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
        />-->

        <v-spacer />

        <v-menu
          bottom
          left
          offset-y
          origin="top right"
          transition="scale-transition"
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              min-width="0"
              elevation="1"
              color="#015A6C"
              fab
              dark
              small
              text
              v-bind="attrs"
              v-on="on"
            >
              <!--<v-badge color="red" overlap bordered>
              <template v-slot:badge>
                <span>5</span>
              </template>

              <v-icon>mdi-account</v-icon>
            </v-badge>-->
              <v-icon dark>mdi-account</v-icon>
            </v-btn>
          </template>

          <v-list :tile="false" nav>
            <div>
              <app-bar-item>
                <v-list-item-title
                  title="Logout"
                  class="dropdown sidebar-nav-item"
                >
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-expanded="false"
                  >
                    English
                    <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu" role="menu">
                    <v-list-item-title title="Logout"
                      ><a href="/">Ελληνικά</a></v-list-item-title
                    >
                  </ul>
                </v-list-item-title>

                <v-list-item-title title="Logout" class="sidebar-nav-item"
                  ><a href="/#features">Features</a></v-list-item-title
                >
                <v-list-item-title title="Logout" class="sidebar-nav-item"
                  ><a href="/#pricelist">Pricelist</a></v-list-item-title
                >
                <v-list-item-title title="Logout" class="sidebar-nav-item"
                  ><a href="/">Support</a></v-list-item-title
                >
              </app-bar-item>
            </div>
          </v-list>
        </v-menu>
      </v-app-bar>
      <!--<nav-menu v-if="currentUser" />-->
      <v-content>
        <v-container style="background: #e4edf3;" fluid>
          <div style="display: flex; width: 100%;">
            <div
              style="
                width: 100%;
                background-color: #e4edf3;
                height: auto;
                min-height: 100vh;
              "
            >
              <transition name="slide-fade" mode="out-in">
                <router-view></router-view>
              </transition>
            </div>
          </div>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>
<style></style>
<script>
import { mapState, mapMutations } from "vuex";
/* EventBus.$on('updated', clickCount => {
         this.buildingId = clickCount

     });*/
export default {
  name: "app",
  data() {
    return {
      renderComponent: true,
      count: 0,
      x: 0,
      drawerWasClosed: false
    };
  },
  props: {},
  beforeCreate() {},
  watch: {
    drawer(val) {
      if (!val) {
        this.drawerWasClosed = true;
        setTimeout(() => {
          this.drawerWasClosed = false;
        }, 0);
      }
    }
    /* value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      alert(this.value);
      //this.fetchStatement();
    },*/
  },
  computed: {
    ...mapState(["drawer"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    }
  },
  mounted() {},

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER"
    }),

    getCoordinateX: function(event) {
      this.x = event.clientX;
    },

    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;
    }
  }
};
</script>

<style>
/*** TRANSITIONS ***/
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(10px);
  opacity: 0;
}

.slide-up-enter-active {
  transition: all 0.2s ease;
}

.slide-up-move {
  transition: transform 0.8s ease-in;
}

.noDisplay {
  display: none;
}

@media (min-width: 1264px) {
  .leftMargin {
    margin-left: 245px;
  }
}
</style>
